module.exports = __webpack_public_path__ + "img/La-Tribune-logo.e3937a60.png";